import { isPrimitive } from 'radash';
import '@nettbureau/theme';
import { parseFlexDirection, parseFlexAlignment, parseGap } from '../parsers/flex.js';
import 'polished';

/**
 * Generates CSS for applying flexbox styles to an element.
 *
 * @param options - Options for the mixin.
 */ function flex(options) {
    const { align, direction = 'horizontal', gap, inline, justify, reversed = false, wrap } = options;
    return (theme)=>[
            {
                display: inline ? 'inline-flex' : 'flex',
                flexDirection: parseFlexDirection(direction, reversed)
            },
            align && {
                alignItems: parseFlexAlignment(align)
            },
            gap && {
                gap: parseGap(theme, gap)
            },
            justify && {
                justifyContent: parseFlexAlignment(justify)
            },
            isPrimitive(wrap) && {
                flexWrap: wrap ? 'wrap' : 'nowrap'
            }
        ];
}

export { flex };
//# sourceMappingURL=flex.js.map
